import React from 'react';
import { Table } from 'react-bootstrap';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { getLocalizedName } from '../localization/LocalizedString';
import checkGreen from '../images/check_green.png';

class InstallationServiceDevices extends React.Component {
  render() {
    const {
      translate,
      currentLanguage,
      importedDevices,
      selectedDevices,
      onAddChangeHandler,
      onRemoveChangeHandler,
      isEditState,
      session: { isAdmin = false },
      currentFormStatus,
      onUncomplitedClickHandler,
      onNotInstalledClickHandler,
      deviceStatusValues,
      onInputChange,
    } = this.props;

    let deviceHasStatus = true;
    if (currentFormStatus.value !== 'WEB_TO_WEB_UNCOMPLETED') {
      deviceHasStatus = false;
      selectedDevices.every((device) => {
        if (device.status && device.status.value !== '') {
          deviceHasStatus = true;
          return false;
        }
        return true;
      });
    }

    return (
      <div>
        <Table bordered>
          <thead className="table-head">
            <tr>
              <th>{translate('service_installation.device_title')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <h3 className="table-body-text-padding">
                  {translate('service_installation.installation')}
                </h3>
                <div className="row">
                  <div className="column table-body-padding">
                    <Table className="restricted-device-table" bordered>
                      <thead className="device-table-header">
                        <tr>
                          <th className={`${!isAdmin && isEditState ? 'device-table-header-disabled' : ''}`}>
                            {translate('service_installation.name')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {importedDevices.map((device) => (
                          <tr key={device.id}>
                            <td>
                              <p>{getLocalizedName(device, currentLanguage)}</p>
                            </td>
                            <td className="device-table-button">
                              <button disabled={!isAdmin && isEditState}
                                      className="table-button-property table-button-add"
                                      type="button"
                                      onClick={() => onAddChangeHandler(device)}>
                                <i className="fa fa-plus" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  <div className="table-body-padding column">
                    <Table className="restricted-device-table" bordered responsive>
                      <thead className="device-table-header">
                        <tr>
                          <th className={`${!isAdmin && isEditState ? 'device-table-header-disabled table-min-width-th' : 'table-min-width-th'}`}>
                            {translate('service_installation.name')}
                          </th>
                          {deviceHasStatus
                            && (
                            <React.Fragment>
                              <th className={`${!isAdmin && isEditState ? 'device-table-header-disabled table-min-width3' : 'table-min-width3'}`}>{translate('service_installation.device_status.device_uncomplete')}</th>
                              <th className={`${!isAdmin && isEditState ? 'device-table-header-disabled table-min-width3' : 'table-min-width3'}`}>{translate('service_installation.device_status.device_notInstalled')}</th>
                              <th className={`${!isAdmin && isEditState ? 'device-table-header-disabled table-min-width6' : 'table-min-width6'}`} />
                            </React.Fragment>
                            )}
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDevices.map((device, idx) => (
                          <React.Fragment>
                            <tr key={idx}>
                              <td className="table-min-width">
                                {getLocalizedName(device, currentLanguage)}
                              </td>
                              {deviceHasStatus
                                && (
                                <React.Fragment>
                                  <td className="table-min-width4_1">
                                    <input
                                      type="radio"
                                      onClick={() => onUncomplitedClickHandler(device)}
                                      disabled={device.status && device.status.value === deviceStatusValues.COMPLETED}
                                      checked={device.status && device.status.value === deviceStatusValues.UNCOMPLETED} />
                                  </td>
                                  <td className="table-min-width4_2">
                                    <input
                                      type="radio"
                                      onClick={() => onNotInstalledClickHandler(device)}
                                      disabled={device.status && device.status.value === deviceStatusValues.COMPLETED}
                                      checked={device.status && device.status.value === deviceStatusValues.NOT_INSTALLED} />
                                  </td>
                                </React.Fragment>
                                )}
                              <td className="device-table-button">
                                {device.status && device.status.value === deviceStatusValues.COMPLETED
                                  ? <img alt="" src={checkGreen} style={{ height: 30, width: 30 }} />
                                  : (
                                    <button disabled={!isAdmin && isEditState}
                                            className="table-button-property table-button-remove"
                                            onClick={() => onRemoveChangeHandler(device)}
                                            type="button">
                                      <i className="fa fa-minus" />
                                    </button>
                                  )}
                              </td>
                            </tr>
                            {currentFormStatus.value !== ''
                                && ((device.status && device.status.reason && device.status.reason !== '')
                                    || (device.status && device.status.value === deviceStatusValues.UNCOMPLETED))
                                && (
                                <tr>
                                  <td colSpan={4} style={{ paddingLeft: '7px' }}>
                                    <span>
                                      {translate('service_installation.reason_title')}
                                      {' '}
                                    </span>
                                    <input className="table-min-width5 form-input devices-reason-input"
                                           style={{ width: '435px' }}
                                           type="text"
                                           required
                                           defaultValue={device.status && device.status.reason ? device.status.reason : null}
                                           value={device.status && device.status.reason ? device.status.reason : ''}
                                           onBlur={(e) => onInputChange(e)}
                                           onChange={(e) => onInputChange(e, false)} // False -> Not for instruction field
                                           disabled={device.status && (device.status.value === deviceStatusValues.NOT_INSTALLED
                                           || device.status.value === deviceStatusValues.COMPLETED)}
                                           id={device.id} />
                                  </td>
                                </tr>
                                )}
                            {currentFormStatus.value !== ''
                                && ((device.status && device.status.instructions && device.status.instructions !== '')
                                    || (device.status && device.status.value === deviceStatusValues.UNCOMPLETED))
                                && (
                                <tr>
                                  <td colSpan={4} style={{ paddingLeft: '7px' }}>
                                    <span>
                                      {' '}
                                      {translate('service_installation.device_installation_instruction')}
                                      {' '}
                                    </span>
                                    <input className="table-min-width5 form-input devices-reason-input"
                                           style={{ width: '435px' }}
                                           defaultValue={device.status && device.status.instructions !== undefined ? device.status.instructions : null}
                                           value={device.status && device.status.instructions !== undefined ? device.status.instructions : ''}
                                           type="text"
                                           required
                                           onChange={(e) => onInputChange(e, true)} // True -> For instruction field
                                           id={device.id} />
                                  </td>
                                </tr>
                                )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    currentLanguage: activeLanguage?.code || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceDevices);
